// Modules
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import _ from 'lodash';

import { PageContent } from 'components/page';
import { RoundLoader } from 'components/widgets/state-indicators/loader';
import DriveFilesList from 'components/models/files/drive-files-list';
import EmptyPagePlaceholder from 'components/page/empty-page-placeholder';
import Ticket from 'services/data/ticket';

import useTicket from '../hooks/useTicket';


function TicketFiles({ params }) {
  const { ticket, files, updateTicket, reloadFiles } = useTicket(params.ticketId);
  const [fetching, setFetching] = useState(false);

  function addFolder() {
    setFetching(true);

    Ticket.update({ id: ticket.id, folder: { filename: ticket.description } })
      .tap((updated) => updateTicket({ folder: updated.folder }))
      .tap(reloadFiles);
  }

  if (!ticket || _.isEmpty(ticket)) return null;
  if (fetching && !files) return <RoundLoader color="#34495e" className="page-loader" />;
  if (!ticket.folder) return <EmptyPagePlaceholder onClick={addFolder} src="svg/google-drive.svg">Click here to add a folder to this ticket!</EmptyPagePlaceholder>;

  return (
    <PageContent className="ticket p-0">
      <div className="ticket-files">
        <DriveFilesList onFileAdd={reloadFiles} files={files} folder={ticket.folder} />
      </div>
    </PageContent>
  );
}

TicketFiles.propTypes = {
  params: PropTypes.object
};

export default TicketFiles;
